<template>
  <div class="index home">
    <!-- Hero Section -->
    <section class="is-full hero video">
      <span
        class="wistia_embed wistia_async_vjw7uyzpnb popover=true popoverContent=link self-center my-auto"
        style="display:inline;position:relative"
      ><a href="#">
          <b-icon
            icon="play"
            size="is-large"
          ></b-icon>
        </a></span>
    </section>

    <main>
      <!-- Professionals Search Section-->
      <div id="busca-profissionais">
        <SearchProfessionals />
      </div>

      <!-- Blog Section -->
      <section
        id="blog"
        class="content-section blog-posts alt-background"
      >
        <div class="container">
          <span class="section-title">
            <h1>Blog</h1>
            <h3>
              Confira o conteúdo publicado pelos profissionais
              <br>cadastrados em nosso site
            </h3>
          </span>

          <!-- Blog Posts -->
          <BlogPosts
            :show-author="true"
            :maxResults=12
            classes="column is-one-third-desktop is-one-quarter-fullhd"
            :infiniteScroll="false"
          />
        </div>
      </section>

      <!-- Nearby Professionals -->
      <div>
        <ProfessionalsCarousel
          :professionals="professionals"
          title="Profissionais Próximos"
          queryType="location"
        />
      </div>
    </main>

  </div>
</template>

<script>
import SearchProfessionals from '@/components/SearchProfessionals'
import ProfessionalsCarousel from '@/components/ProfessionalsCarousel/ProfessionalsCarousel'
import BlogPosts from '@/components/BlogPosts/'
import { mapState } from 'vuex'

export default {
  name: 'Index',
  components: {
    SearchProfessionals,
    ProfessionalsCarousel,
    BlogPosts
  },
  mounted () {
    // Wistia
    const wistiaBase = document.createElement('script')
    const wistiaAssets = document.createElement('script')
    wistiaBase.setAttribute('src', 'https://fast.wistia.com/embed/medias/vjw7uyzpnb.jsonp')
    wistiaAssets.setAttribute('src', 'https://fast.wistia.com/assets/external/E-v1.js')
    document.head.appendChild(wistiaBase)
    document.head.appendChild(wistiaAssets)
  },
  computed: {
    ...mapState(['locationName'])
  }
}
</script>
